module.exports = __webpack_public_path__ + "img/logo_big.abf5968b.svg";